function setMercaUserCookie(name, value, minutes) {
  const date = new Date();
  date.setTime(date.getTime() + minutes * 60 * 1000); // Set expiry date
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; path=/; Secure;`;
}

function getMercaUserCookieValue(allCookies, cookieName) {
  for (let cookie of allCookies) {
    cookie = cookie.trim();
    if (cookie.indexOf(`${cookieName}=`) === 0) {
      return cookie.substring(cookieName.length + 1);
    }
  }
  return null;
}

function setProfileCookie(RepeatCookie, EngagedCookie, AffluentCookie) {
  const mapping = [
    { Engaged: "1", Repeat: "1", Affluent: "1", profile: "BEA" },
    { Engaged: "1", Repeat: "1", Affluent: "0", profile: "BEV" },
    { Engaged: "1", Repeat: "0", Affluent: "1", profile: "BA" },
    { Engaged: "1", Repeat: "0", Affluent: "0", profile: "BV" },
    { Engaged: "0", Repeat: "1", Affluent: "1", profile: "EA" },
    { Engaged: "0", Repeat: "1", Affluent: "0", profile: "EV" },
    { Engaged: "0", Repeat: "0", Affluent: "1", profile: "A" },
    { Engaged: "0", Repeat: "0", Affluent: "0", profile: "V" }
  ];

  const result = mapping.find(item =>
    +item.Engaged === +EngagedCookie &&
    +item.Repeat === +RepeatCookie &&
    +item.Affluent === +AffluentCookie
  );

  return setMercaUserCookie('ma_p', result?.profile, 30);
}

function getProfile(RepeatCookie, EngagedCookie, AffluentCookie) {
  const mapping = [
    { Engaged: "1", Repeat: "1", Affluent: "1", profile: "BEA" },
    { Engaged: "1", Repeat: "1", Affluent: "0", profile: "BEV" },
    { Engaged: "1", Repeat: "0", Affluent: "1", profile: "BA" },
    { Engaged: "1", Repeat: "0", Affluent: "0", profile: "BV" },
    { Engaged: "0", Repeat: "1", Affluent: "1", profile: "EA" },
    { Engaged: "0", Repeat: "1", Affluent: "0", profile: "EV" },
    { Engaged: "0", Repeat: "0", Affluent: "1", profile: "A" },
    { Engaged: "0", Repeat: "0", Affluent: "0", profile: "V" }
  ];

  const result = mapping.find(item =>
    +item.Engaged === +EngagedCookie &&
    +item.Repeat === +RepeatCookie &&
    +item.Affluent === +AffluentCookie
  );

  return result?.profile;
}

function getDeviceDimensions() {
  return {
    screen: {
      width: window.screen.width,
      height: window.screen.height,
    },
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    pixelRatio: window.devicePixelRatio || 1,
  };
}

function getMercaExistingCookie() {
  const cookies = document.cookie ? document.cookie.split(';') : [];

  return {
    existingRepeatCookie: getMercaUserCookieValue(cookies, 'ma_r'),
    existingEngagedCookie: getMercaUserCookieValue(cookies, 'ma_e'),
    existingAffluentCookie: getMercaUserCookieValue(cookies, 'ma_a'),
    existingProfileCookie: getMercaUserCookieValue(cookies, 'ma_p'),
  };
}


function userIdentification() {
  const browserCookie = document.cookie ? document.cookie.split(';') : [];
  const params = new URLSearchParams(window.location.search);
  const MercaAS = params.get('MercaAS');

  const {
    existingRepeatCookie,
    existingEngagedCookie,
    existingAffluentCookie,
    existingProfileCookie
  } = getMercaExistingCookie();

  const currentRepeatCookie = MercaAS === 'MAS3' ? 1 : existingRepeatCookie || null;
  const currentEngagedCookie = window.INIT_CART_COUNT > 0 ? 1 : existingEngagedCookie || 0;
  const currentAffluentCookie = existingAffluentCookie || null;

  if (!currentRepeatCookie || !currentAffluentCookie) {
    const requestData = {
      brand: "DOODLAGE",
      cookie: {
        isRepeat: currentRepeatCookie,
        isAffluent: currentAffluentCookie,
      },
      _ga: getMercaUserCookieValue(browserCookie, '_ga') || null,
      deviceSize: getDeviceDimensions(),
    };

    fetch('https://api.merca.ai/v2/user-identification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        setMercaUserCookie('ma_a', data.isAffluent, 90 * 24 * 60);
        setMercaUserCookie('ma_r', data.isRepeat, 90 * 24 * 60);

        if (!existingEngagedCookie) {
          setMercaUserCookie('ma_e', currentEngagedCookie ? 1 : 0, 30);
          setProfileCookie(data.isRepeat, currentEngagedCookie, data.isAffluent);
          gtag("event", "shopper_identification", {
            send_to: "G-99KL08SESC",
            profile: getProfile(data.isRepeat, currentEngagedCookie, data.isAffluent) || 'A',
          });
        }

      })
      .catch((err) => console.log(err));
  } else {
    if (!existingEngagedCookie) {
      setMercaUserCookie('ma_e', currentEngagedCookie ? 1 : 0, 30);
      setProfileCookie(currentRepeatCookie, currentEngagedCookie, currentAffluentCookie);
      gtag("event", "shopper_identification", {
        send_to: "G-99KL08SESC",
        profile: getProfile(currentRepeatCookie, currentEngagedCookie, currentAffluentCookie) || 'A',
      });
    }
  }

}

function checkAndFetch() {
  const checkInterval = 1000;
  const timeoutDuration = 60000;
  let elapsedTime = 0;

  function findGid() {
    const gid = document.cookie.match(/_ga=([^;]+)/);
    if (gid) {
      clearInterval(checkIntervalId);
      userIdentification();
      return;
    } else if (elapsedTime < timeoutDuration) {
      elapsedTime += checkInterval;
      return;
    } else {
      clearInterval(checkIntervalId);
      userIdentification();
      return;
    }
  }

  const checkIntervalId = setInterval(findGid, checkInterval);
}

checkAndFetch();
